import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bd1bf1c6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=bd1bf1c6&prod&lang=stylus&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=bd1bf1c6&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1bf1c6",
  null
  
)

export default component.exports